import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { getbundledata, getdata, getdatanoauth, WAITINGGIF, sendwhatsappmessageapi } from '../../util/global';

const reports = [
  {
    id: 'bills',
    title: 'Bills - Attachment Missing',
    description: 'Vendor bills booked without an invoice copy attached.',
    icon: '📎',
    frequency: 'Daily',
    route: '/billattachmentcheck',
  },
  {
    id: 'expenses',
    title: 'Expenses - Attachment Missing',
    description: 'Expenses booked without a receipt/bill copy attached.',
    icon: '🧾',
    frequency: 'Daily',
    route: '/expenseattachmentcheck',
  },
  {
    id: 'vendorattachment',
    title: 'Vendors - Attachment Missing',
    description: 'Vendors without required documents like PAN, GST, etc.',
    icon: '👨‍💼',
    frequency: 'Daily',
    route: '/vendorattachmentcheck',
  },
  {
    id: 'composites',
    title: 'Items - Stock Mismatch',
    description: 'Items with differing Available for Sale values',
    icon: '▦',
    frequency: 'Daily',
    route: '/itemstockcheck',
  },
  {
    id: 'negative',
    title: 'Items −ve Inventory',
    description: 'Active, sellable items showing a negative stock on hand.',
    icon: '⬡',
    frequency: 'Daily',
    route: '/itemnegativestockcheck',
  },
    {
    id: 'incorrectname',
    title: 'Items - Name',
    description: 'Units of measurement not present in the name',
    icon: '⬡',
    frequency: 'Daily',
    route: '/itemnamecheck',
  },
  {
    id: 'vendorcheck',
    title: 'Items - Vendor Missing',
    description: 'Preferred vendors missing',
    icon: '⬡',
    frequency: 'Daily',
    route: '/itemvendorcheck',
  },
    {
    id: 'buncheck',
    title: 'Assemblies',
    description: 'BUN total > composite item cost price',
    icon: '⬡',
    frequency: 'Daily',
    route: '/bundlecheck',
  },
  {
    id: 'amazonorders',
    title: 'Amazon - Orders Not in Zoho',
    description: 'Amazon sales orders not booked in Zoho.',
    icon: '📦',
    frequency: 'Daily',
    route: '/amazonordercheck',
  },
];

const KitstersDashboard = () => {
  const navigate = useNavigate();

  const monitored = reports.length;
  const ran       = reports.filter(r => typeof r.toReview === 'number');
  const hasRun    = ran.length > 0;
  const totalOpen = ran.reduce((s, r) => s + r.toReview, 0);
  const needAttn  = ran.filter(r => r.toReview > 0).length;

  const barColor = !hasRun ? 'var(--terra)' : totalOpen > 0 ? 'var(--danger)' : 'var(--success)';
  const headline = !hasRun
    ? 'No audits run yet'
    : totalOpen > 0
    ? `${totalOpen} issues across ${needAttn} reports`
    : 'Everything checks out';

  const [billdata, setbilldata] = useState([]);
  const [compositeitemdata, setcompositeitemdata] = useState([]);
  const [itemdata, setitemdata] = useState([]);
  const [expensedata, setexpensedata] = useState([]);
  const [negativeitemdata, setnegativeitemdata] = useState([]);
  const [namecheckitemdata, setnamecheckitemdata] = useState([]);
  const [vendoritemdata, setvendoritemdata] = useState([]);
  const [bundledata, setbundledata] = useState([]);
  const [vendorattachmentdata, setvendorattachmentdata] = useState([]);
  const params = new URLSearchParams(window.location.search);


  const fetchdata = async () => {
    const adminuserid = window.APPUSER?.user?.token ? window.APPSETTING.adminuserid : params.get('adminuserid');
    try {
      let data = await getdatanoauth({ zohodatatype: 'bills', _adminuserid: adminuserid }, '/zohodatanoauth');
      setbilldata(data.data);
      $(".countbills").html( data.data.length);

      data = await getdatanoauth({ zohodatatype: 'expenses', _adminuserid: adminuserid }, '/zohodatanoauth');
      setexpensedata(data.data);
      $(".countexpenses").html( data.data.length);

      data = await getdatanoauth({zohodatatype: 'contacts', _adminuserid: adminuserid, tag: 'checkattachment', zohofilterparams:'contact_type=vendor&sort_column=outstanding_payable_amount_bcy' }, '/zohodatanoauth');
      setvendorattachmentdata(data.data);
      $(".countvendorattachment").html( data.data.length);

      data = await getdatanoauth({ zohodatatype: 'compositeitems', _adminuserid: adminuserid, zohoresponsekey: 'composite_items' }, '/zohodatanoauth');
      setcompositeitemdata(data.data);
      const compositlen = data.data.length;

      data = await getdatanoauth({ zohodatatype: 'items', _adminuserid: adminuserid, tag:"stockmismatch" }, '/zohodatanoauth');
      setitemdata(data.data);
      $(".countcomposites").html( data.data.length + compositlen);

      data = await getdatanoauth({ zohodatatype: 'items', _adminuserid: adminuserid, tag:"checknegativestock" }, '/zohodatanoauth');
      setnegativeitemdata(data.data);
      $(".countnegative").html( data.data.length);

      data = await getdatanoauth({ zohodatatype: 'items', _adminuserid: adminuserid, tag:"checkname" }, '/zohodatanoauth');
      setnamecheckitemdata(data.data);
      $(".countincorrectname").html( data.data.length);

      data = await getdatanoauth({ zohodatatype: 'items', _adminuserid: adminuserid, tag:"checkvendor" }, '/zohodatanoauth');
      setvendoritemdata(data.data);
      $(".countvendorcheck").html( data.data.length);

      data = await getbundledata({ zohodatatype: 'bundles', _adminuserid: adminuserid }, '/zohodatanoauth');
      setbundledata(data.data);

      $(".countbuncheck").html( data.data.length);

      data = await getdatanoauth({ datatype: 'amazonorders', _adminuserid: adminuserid }, '/amazonordercheck');
      $(".countamazonorders").html( data.data.length);
    } catch (ex) {
      alert (ex.message);
    }
  };

  const refreshcache = async () => {
    $(".cachestatus").html(" | syncing from zoho " + WAITINGGIF)
    await getdata({}, "/clearzohocache");
    window.location.reload();
  };

  useEffect(() => {
    fetchdata();
  }, []);

  return (
    <>
      {/* Overview Band 
      
      <div className="ovb">
        <div className="ovb-bar" style={{ background: barColor }} />
        <div className="ovb-text">
          <div className="ovb-headline">{headline}</div>
          <div className="ovb-subtitle">
            Automated data audits over Zoho Books{hasRun ? ' · last run today' : ''}
          </div>
        </div>
        <div className="ovb-stats">
          <div className="ovb-stat">
            <div
              className="ovb-stat-value"
              style={{ color: hasRun && needAttn > 0 ? 'var(--danger)' : 'var(--muted)' }}
            >
              {hasRun ? needAttn : '—'}
            </div>
            <div className="ovb-stat-label">Reports need attention</div>
          </div>
          <div className="ovb-stat">
            <div className="ovb-stat-value" style={{ color: 'var(--ink)' }}>
              {hasRun ? totalOpen : '—'}
            </div>
            <div className="ovb-stat-label">Open issues across all reports</div>
          </div>
          <div className="ovb-stat">
            <div className="ovb-stat-value" style={{ color: 'var(--ink)' }}>
              {monitored}
            </div>
            <div className="ovb-stat-label">Reports monitored</div>
          </div>
        </div>
      </div>
      */}
      {/* Report hub */}
      <div className="report-hub-header">
        <span className="report-hub-label">
          {params.get("title") || "All Reports"} | 
          <span onClick={()=> {refreshcache();}}>sync data</span> <span class="cachestatus"></span>
        </span>
        <span className="report-hub-count">{reports.length} active</span>
      </div>
      <div className="report-card-grid">
        {reports.filter(r => {
          const mode = params.get("mode");
          return !mode || r.title.match(new RegExp(mode, "gi"));
        }).map(r => (
          <div key={r.id} className="report-card" onClick={() => navigate(r.route)}>
            <div className="report-card-inner">
              <div className="report-icon-chip">{r.icon}</div>
              <div className="report-card-body">
                <div className="report-card-title">{r.title} <br/> 
                  <span style={{color:'red'}}>Tasks <span className={`count${r.id}`}><img src="/css/whatsappapi/waiting.gif" style={{width:'23px'}}/></span></span>
                </div>
                <div className="report-card-desc">{r.description}</div>
                <div className="report-card-meta"></div>
              </div>
            </div>
            <div className="report-card-footer">
              <span className="report-open-btn">Open →</span>
            </div>
          </div>
        ))}
        <div className="report-card report-card--placeholder">
          <div className="report-placeholder-title">More reports coming</div>
          <div className="report-placeholder-sub">New audits drop in here as they're built.</div>
        </div>
      </div>
    </>
  );
};

export default KitstersDashboard;
